import React from "react";
import { Form } from "react-bootstrap";
import formFields from "./node-formfields";
import AvailabilityField from "./AvailabilityField";

export const NodeForm = ({ onChange, sharedRoomCount, availabilityStatus, onAvailabilityChange }) => (
  <div className="node-editor__fields">
    {formFields.map(({ label, name, type, required, min, step, help }) => (
      <Form.Group key={name} controlId={`new-node-${name}`}>
        <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
        <Form.Control name={name} type={type} min={min} step={step} required={required} value={name === "sharedRoomCount" ? sharedRoomCount : undefined} onChange={onChange(name)} />
        {help && <Form.Text className="text-muted">{help}</Form.Text>}
      </Form.Group>
    ))}
    <AvailabilityField
      id="new-node-availability"
      isNode
      value={availabilityStatus}
      onChange={onAvailabilityChange}
    />
  </div>
);

export default NodeForm;
